import { render } from "./index.vue?vue&type=template&id=0f862b80&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=0f862b80&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f862b80"]])

export default __exports__